<template>
	<div>
		<a-spin :spinning="loading" tip="Loading...">
			<CountrySelect v-model="country" :getData="search" style="padding-bottom: 0px"
				placeholder="您想看哪个国家&地区的品类趋势？" v-if="mediaType !== 'GOOGLE'"
			></CountrySelect>
			<CategorySelect v-model="categoryCodeList" ref="categorySelect" :getData="search" multiple
				placeholder="您想看品类或子类的趋势？最多选6个"
			></CategorySelect>
			<div class="chart-box">
				<a-row class="filter" type="flex" justify="space-between" style="margin-bottom: 10px">
					<a-col>
						<span>核心指标：</span>
						<a-select
							v-model="exportType"
							style="width: 120px"
							@change="search"
						>
							<a-select-option value="5">花费指数</a-select-option>
							<a-select-option value="2">展示指数</a-select-option>
							<a-select-option value="1">点击指数</a-select-option>
							<a-select-option value="4">CTR</a-select-option>
							<a-select-option value="3">CPC</a-select-option>
							<a-select-option value="6">CPM</a-select-option>
						</a-select>					
						<span style="margin-left: 24px">时间维度：</span>
						<a-select
							v-model="dateDimension"
							style="width: 120px"
							@change="search"
						>
							<a-select-option value="0">天</a-select-option>
							<a-select-option value="1">周</a-select-option>
							<a-select-option value="2">月</a-select-option>
							<a-select-option value="3">季</a-select-option>
						</a-select>
						<span style="margin-left: 24px">时间范围：</span>
						<TagDateRange style="width: 250px" v-model="dateRange" :getList="getList" tdDisabled></TagDateRange>
					</a-col>
				</a-row>
				<v-chart ref="barchart" :options="options" autoresize style="width: 100%"/>
			</div>
		</a-spin>
	</div>
</template>
<script>
import { trendByCategory, getTrendCategory } from '@/api/template'
import mixin from './rankMixin.js'
import moment from 'moment';
import TagDateRange from "@/components/TagDateRange";

import CountrySelect from './countrySelect'
import CategorySelect from './categorySelect'
 
const columns = [
	{
		title: '品类',
		dataIndex: 'categoryName',
		width: 250,
		align: 'left',
	},
]
export default {
	name: 'CategoryTrend',
	mixins: [mixin],
	data() {
		return {
			exportType: '5',
			data: [],
			country: 'ALL',
			dateDimension: '1',
			categoryCodeList: [],
      dateRange: [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],
		}
	},
	props: ['mediaType'],
	components: {
		CategorySelect,
		CountrySelect,
		TagDateRange
	},
	computed: {
		columns() {
			let obj = {
				title: this.exportTypeMap[this.exportType].name,
				dataIndex: this.exportTypeMap[this.exportType].value,
				width: 250,
				align: 'right',
				scopedSlots: { customRender: 'number' },
			}
			return [...columns, obj]
		}
	},
	methods: {
		getList() {
      this.loading = true
			this.data = []
			this.options.xAxis[0].data = []
			this.options.series = []
			this.options.dataZoom[0].show = false   
			trendByCategory({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
				country: this.country === 'ALL'?undefined:this.country,
				categoryCodeList: this.categoryCodeList,
				exportType: this.exportType,
				startDate: this.dateRange[0],
				endDate: this.dateRange[1],
				dateDimension: this.dateDimension,
				mediaType: this.mediaType,
        ...this.params
      }).then((res) => {
        this.data = res.data || []
				let options = JSON.parse(JSON.stringify(this.options))
				for (let i = 0; i < this.data.length; i++) {
					const ele = this.data[i];
					options.series[i] = {
						data: [],
						type: "line",
						itemStyle: {
							borderRadius: null,
							color: this.$enum.ChartOptionsColor[i],
							barBorderRadius: [4, 4, 0, 0],
						},
					}
					options.series[i].name = ele.categoryName
					options.xAxis[0].data = ele.categoryTrendList.map(v => v.dateX)
					options.series[i].data = ele.categoryTrendList.map(v => v[this.exportTypeMap[this.exportType].value])
				}
				options.yAxis[0].axisLabel.formatter = '{value}' + this.exportTypeMap[this.exportType].unit
				options.dataZoom[0].show = options.xAxis[0].data.length > 11
				this.options = options
      }).finally(() => this.loading = false)
    },
		getTrendCategory() {
      this.loading = true
			getTrendCategory().then(res => {
				this.categoryCodeList = res.data.map(v => v.categoryCode)
				this.$refs.categorySelect.addCache(res.data || [])
				this.getList()
			})
		}
	},
	mounted() {
		this.getTrendCategory()
	},
}
</script>
<style lang="less" scoped>
.export-btn {
	margin-right: 24px;
}
</style>